import ProgrammeItem from './ProgrammeItem';

export default function ProgrammeDay(day) {

    return `

        <section
            id="day-${day.id}"
            class="programme-day">

            <header class="programme-day__header">

                <h2>

                    ${day.title}

                </h2>

                <span>

                    ${day.date}

                </span>

            </header>

            <div class="programme-day__items">

                ${day.entries
                    .map(entry => ProgrammeItem(entry))
                    .join('')}

            </div>

        </section>

    `;

}
